// extracted by mini-css-extract-plugin
export default {"totalContainer":"Total_totalContainer__0Rst2"};